import { CSSProperties } from 'react';
import { Colors } from '../themes/colors';
import { Box } from './Box';

interface IDividerProps {
  color?: CSSProperties['backgroundColor'];
  height?: CSSProperties['height'];
  marginVertical?: number;
  width?: CSSProperties['width'];
}

export const Divider = ({
  color = Colors.neutral_100,
  height = 2,
  marginVertical = 16,
  width = 'auto',
}: IDividerProps) => (
  <Box width={width} height={height} backgroundColor={color} marginVertical={marginVertical} />
);
